import React from "react";
import { Row, Col } from "reactstrap";
import { useWizard } from "react-use-wizard";
import { useFormContext } from "react-hook-form";
import s from "./styles.scss";
import withStyles from "isomorphic-style-loader/withStyles";
import PrimaryButton from "../../../../../../../toolkit/primaryButton";

interface StepFooterProps {
  onFinish: (data: any) => void;
  fieldsByStep: string[][];
  loading?: boolean;
  loadingText?: string;
  loadingAnimation?: string;
  onSaveProgress?: (data: any, currentStep: number) => Promise<void>;
}

const StepFooter: React.FC<StepFooterProps> = ({
  onFinish,
  fieldsByStep,
  loading,
  loadingText,
  loadingAnimation,
  onSaveProgress
}) => {
  const { nextStep, previousStep, activeStep, isLastStep } = useWizard();
  const { trigger, getValues } = useFormContext();

  const handleNext = async () => {
    const valid = await trigger(fieldsByStep[activeStep] || []);

    if (valid) {
      const allData = getValues();

      if (isLastStep) {
        await onFinish(allData);
      } else {
        if (onSaveProgress) {
          await onSaveProgress(allData, activeStep);
        }
        await nextStep();
      }
    }
  };

  return (
    <Col md={12} className={`${s.stepFooterContainer} pt-4 pb-5`}>
      <Row className="justify-content-center">
        <Col md={7}>
          <hr className="border-secondary" />
        </Col>
      </Row>
      <Row className="justify-content-center mt-3">
        <Col md={4} className="d-flex justify-content-start">
          <PrimaryButton
            onClick={() => previousStep()}
            className="ms-3"
            disabled={activeStep === 0}
          >
            Back
          </PrimaryButton>
        </Col>
        <Col md={4} className="d-flex justify-content-end">
          <PrimaryButton
            onClick={() => handleNext()}
            className="me-3"
            loading={loading}
            loadingText={loadingText}
            loadingAnimation={loadingAnimation}
          >
            {isLastStep ? "Finish" : "Next"}
          </PrimaryButton>
        </Col>
      </Row>
    </Col>
  );
};

export default withStyles(s)(StepFooter);
